/**
 * 初始化快速尺码区域。
 *
 * 首次加载和 AJAX 更新后都可以重复调用。
 */
window.initQuickSizeAreas = function initQuickSizeAreas(
  container = document
) {
  if (!container) return;

  /**
   * container 本身也可能是 quick-size-pending。
   */
  if (
    container.nodeType === Node.ELEMENT_NODE &&
    container.matches(
      '.product-card-quick-area.quick-size-pending'
    )
  ) {
    container.classList.remove('quick-size-pending');
    container.classList.add('quick-size-ready');
  }

  /**
   * 初始化 container 里面的所有快速尺码区域。
   */
  container
    .querySelectorAll?.(
      '.product-card-quick-area.quick-size-pending'
    )
    .forEach((element) => {
      element.classList.remove('quick-size-pending');
      element.classList.add('quick-size-ready');
    });
};


/**
 * 快速尺码点击加购。
 *
 * 使用事件委托，因此 AJAX 插入的新商品不需要重新绑定。
 */
if (!window.quickSizeBound) {
  window.quickSizeBound = true;

  let lastClickTime = 0;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.quick-size');

    if (!button) return;
    if (button.classList.contains('is-loading')) return;
    if (button.dataset.available !== 'true') return;

    const currentTime = Date.now();

    if (currentTime - lastClickTime < 300) {
      return;
    }

    lastClickTime = currentTime;

    const variantId = button.dataset.variantId;

    if (!variantId) return;

    const productFormElement = button.closest('product-form');

    if (!productFormElement) return;

    const form = productFormElement.querySelector(
      '.js-product-form'
    );

    if (!form) return;

    const variantInput = form.querySelector(
      'input[name="id"]'
    );

    const addButton = form.querySelector(
      '[name="add"]'
    );

    if (!variantInput || !addButton) return;

    button.classList.add('is-loading');
    button.disabled = true;

    const loader = button.querySelector(
      '.cart-item__loader'
    );

    if (loader) {
      loader.hidden = false;
    }

    variantInput.value = variantId;

    const clearLoading = () => {
      button.classList.remove('is-loading');
      button.disabled = false;

      if (loader) {
        loader.hidden = true;
      }
    };

    window.setTimeout(clearLoading, 5000);

    addButton.click();
  });
}


/**
 * 移动端打开快速尺码抽屉。
 *
 * 使用事件委托，支持 AJAX 插入的新商品卡片。
 */
if (!window.mobileQuickSizeBound) {
  window.mobileQuickSizeBound = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest(
      '.js-mobile-show-size'
    );

    if (!button) return;

    /**
     * 1024px 开始使用 PC 端样式。
     */
    if (window.innerWidth >= 1024) return;

    const card =
      button.closest('product-card-image-slider') ||
      button.closest('.card') ||
      button.closest('li');

    if (!card) return;

    const quickArea = card.querySelector(
      '.product-card-quick-area'
    );

    if (!quickArea) return;

    const drawer = document.getElementById(
      'mobile-quick-drawer'
    );

    if (!drawer) return;

    const drawerBody = drawer.querySelector(
      '.mobile-quick-drawer__body'
    );

    if (!drawerBody) return;

    button.style.display = 'none';

    /**
     * 将当前商品的尺码表单复制进移动抽屉。
     */
    drawerBody.innerHTML = quickArea.innerHTML;

    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');

    document.documentElement.classList.add(
      'quick-size-drawer-open'
    );
  });
}


/**
 * 关闭移动端快速尺码抽屉。
 */
window.closeQuickDrawer = function closeQuickDrawer() {
  const drawer = document.getElementById(
    'mobile-quick-drawer'
  );

  if (!drawer) return;

  drawer.classList.remove('active');
  drawer.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.remove(
    'quick-size-drawer-open'
  );

  const drawerBody = drawer.querySelector(
    '.mobile-quick-drawer__body'
  );

  if (drawerBody) {
    drawerBody.innerHTML = '';
  }

  document
    .querySelectorAll('.js-mobile-show-size')
    .forEach((button) => {
      button.style.display = '';
    });
}


/**
 * 点击关闭按钮。
 */
document.addEventListener('click', function (event) {
  if (event.target.closest('.drawer-close')) {
    closeQuickDrawer();
  }
});


/**
 * 点击遮罩关闭。
 */
document.addEventListener('click', function (event) {
  if (
    event.target.classList.contains(
      'mobile-quick-drawer__overlay'
    )
  ) {
    closeQuickDrawer();
  }
});


/**
 * Escape 键关闭。
 */
document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    closeQuickDrawer();
  }
});


/**
 * 首次进入页面。
 */
function initializeQuickSizes() {
  const results = document.getElementById(
    'filter-results'
  );

  window.initQuickSizeAreas(results || document);
}


/**
 * 首次页面加载。
 */
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeQuickSizes
  );
} else {
  initializeQuickSizes();
}


/**
 * Collection Tabs AJAX 更新。
 *
 * 注意：事件名必须和你的 Tabs 代码完全一致。
 */
document.addEventListener(
  'collection-product-tabs:updated',
  function () {
    initializeQuickSizes();
    closeQuickDrawer();
  }
);


/**
 * Shopify 原生筛选 AJAX 更新。
 */
document.addEventListener(
  'on:facet-filters:updated',
  function () {
    initializeQuickSizes();
    closeQuickDrawer();
  }
);


/**
 * MutationObserver 兜底。
 *
 * 其他脚本替换商品列表但没有发送事件时，
 * 也能够自动初始化新插入的尺码区域。
 */
function observeQuickSizeResults() {
  const results = document.getElementById(
    'filter-results'
  );

  if (!results) return;

  if (results.dataset.quickSizeObserved === 'true') {
    return;
  }

  results.dataset.quickSizeObserved = 'true';

  const observer = new MutationObserver(
    function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
          }

          window.initQuickSizeAreas(node);
        });
      });
    }
  );

  observer.observe(results, {
    childList: true,
    subtree: true
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    observeQuickSizeResults
  );
} else {
  observeQuickSizeResults();
}


document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.search-toggle');
  const search = document.querySelector('.search-popup');

  if (!btn || !search) return;

  btn.addEventListener('click', () => {
    search.classList.toggle('is-active');
  });
});

document.addEventListener('click', async (e) => {

    const btn = e.target.closest('.copy-btn');

    if (!btn) return;

    const code = btn.dataset.code;
    const textEl = btn.querySelector('.copy-text');

    try {

        await navigator.clipboard.writeText(code);

        textEl.innerText = 'COPIED';

        btn.classList.add('copied');

        setTimeout(() => {
            textEl.innerText = 'COPY';
            btn.classList.remove('copied');
        }, 1500);

    } catch (err) {
        console.log('copy failed');
    }

});

document.querySelectorAll('.promo-code').forEach(item => {
  item.addEventListener('click', async () => {

    const code = item.dataset.code;

    try {
      await navigator.clipboard.writeText(code);

      const original = item.innerHTML;

      item.innerHTML = `
        <span style="font-weight:700;">Copied!</span>
      `;

      setTimeout(() => {
        item.innerHTML = original;
      }, 1500);

    } catch(err) {
      console.error('Copy failed', err);
    }
  });
});




document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".cc-featured-collection-tab");

  sections.forEach(section => {

    const tabs = section.querySelectorAll(".tab-btn");
    const panels = section.querySelectorAll(".tab-panel");
    const headers = section.querySelectorAll(".tab-header");

    function refreshSlider(panel) {
      const slider = panel.querySelector(".slider, .carousel-slider");
      if (!slider) return;

      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));

        if (slider.swiper) slider.swiper.update();
        if (slider.flickity) slider.flickity.resize();
      });
    }

    tabs.forEach(tab => {

      tab.addEventListener("click", () => {

        const id = tab.dataset.tab;

        // tab active
        tabs.forEach(t => t.classList.remove("active"));
        tab.classList.add("active");

        // panel switch
        panels.forEach(p => {
          const isActive = p.dataset.panel === id;
          p.classList.toggle("active", isActive);

          if (isActive) refreshSlider(p);
        });

        headers.forEach(h => {
          const isActive = h.dataset.header === id;
          h.classList.toggle("hidden", !isActive);
        });

      });

    });

  });

});


document.addEventListener("DOMContentLoaded", function() {
    const minusIcon = "https://cdn.shopify.com/s/files/1/2698/7752/files/Line_1.svg?v=1772611981";
    const plusIcon  = "https://cdn.shopify.com/s/files/1/2698/7752/files/Group_141.svg?v=1772611985";

    const accordions_details = document.querySelectorAll(".leggings-accordion-item");

    accordions_details.forEach(item => {
        const header = item.querySelector(".leggings-accordion-header");
        const iconImg = item.querySelector(".leggings-icon-img");

        item.classList.add("active");
        iconImg.src = minusIcon;

        header.addEventListener("click", function() {

            item.classList.toggle("leggings-active");

            if (item.classList.contains("leggings-active")) {
                iconImg.src = minusIcon;
                iconImg.alt = "Collapse";
            } else {
                iconImg.src = plusIcon;
                iconImg.alt = "Expand";
            }
        });

    });

    const accordions_bra = document.querySelectorAll(".accordion-item");

    accordions_bra.forEach(item => {
        const header = item.querySelector(".accordion-header");
        const iconImg = item.querySelector(".icon-img");

        item.classList.add("active");
        iconImg.src = minusIcon;

        header.addEventListener("click", function() {

            item.classList.toggle("active");

            if (item.classList.contains("active")) {
                iconImg.src = minusIcon;
                iconImg.alt = "Collapse";
            } else {
                iconImg.src = plusIcon;
                iconImg.alt = "Expand";
            }
        });

    });

    const accordions_shirt = document.querySelectorAll(".shirt-accordion-item");

    accordions_shirt.forEach(item => {
        const header = item.querySelector(".accordion-header");
        const iconImg = item.querySelector(".icon-img");

        item.classList.add("active");
        iconImg.src = minusIcon;

        header.addEventListener("click", function() {

            item.classList.toggle("active");

            if (item.classList.contains("active")) {
                iconImg.src = minusIcon;
                iconImg.alt = "Collapse";
            } else {
                iconImg.src = plusIcon;
                iconImg.alt = "Expand";
            }
        });

    });


});


// (() => {
//   const wrapper = document.querySelector('.prime-weekend-countdown');

//   if (!wrapper) return;

//   const daysEl = wrapper.querySelector('.js-days');
//   const hoursEl = wrapper.querySelector('.js-hours');
//   const minsEl = wrapper.querySelector('.js-mins');
//   const secsEl = wrapper.querySelector('.js-secs');

//   function getChinaTime() {
//     const now = new Date();
//     const utc = now.getTime() + now.getTimezoneOffset() * 60000;

//     return new Date(utc + 8 * 60 * 60 * 1000);
//   }

//   function getNextResetTime() {
//     const now = getChinaTime();

//     const target = new Date(now);

//     // 今天15:00
//     target.setHours(15, 0, 0, 0);

//     // 如果已经过了15:00，则指向明天15:00
//     if (now >= target) {
//       target.setDate(target.getDate() + 1);
//     }

//     return target;
//   }

//   function updateCountdown() {
//     const now = getChinaTime();
//     const target = getNextResetTime();

//     const diff = target - now;

//     const hours = Math.floor(diff / (1000 * 60 * 60));
//     const mins = Math.floor((diff / (1000 * 60)) % 60);
//     const secs = Math.floor((diff / 1000) % 60);

//     if (daysEl) {
//       daysEl.textContent = '00';
//     }

//     if (hoursEl) {
//       hoursEl.textContent = String(hours).padStart(2, '0');
//     }

//     if (minsEl) {
//       minsEl.textContent = String(mins).padStart(2, '0');
//     }

//     if (secsEl) {
//       secsEl.textContent = String(secs).padStart(2, '0');
//     }
//   }

//   updateCountdown();
//   setInterval(updateCountdown, 1000);
// })();


document.addEventListener(
  'custom:atc-success',
  function(e) {
    const data = e.detail;
    // console.log(data.bundleProducts,"=====");
    const bundleProducts = data.bundleProducts || [];

    const [color, size] = (data.variant_title || '')
      .split(' / ')
      .map(item => item.trim());

    const popup = document.getElementById('atc-popup');

    closeQuickDrawer();

    const recommendHtml = bundleProducts.length
    ? `
      <div class="pairs_border"></div>

      <div class="atc-recommend">
        <div class="atc-recommend__title">Pairs Great With</div>

        <div class="atc-recommend__list slider">
          ${bundleProducts.map(product => `
            <a href="${product.url}" class="atc-recommend__item">
              <img src="${product.image.startsWith('//') ? 'https:' + product.image : product.image}" loading="lazy" decoding="async" alt="${product.title}">
              <div class="atc-recommend__name">${product.title}</div>
              <div class="atc-recommend__price">${product.price_formatted}</div>
            </a>
          `).join('')}
        </div>
      </div>
    `
    : '';

    popup.querySelector('.atc-popup__content').innerHTML = `
      <div class="atc-product">
        <img
          src="${data.image}&width=300"
          loading="lazy"
          decoding="async"
          alt=""
        >

        <div>
          <div class="atc-product-title">
            ${data.product_title}
          </div>

          <div class="atc-info">
            <div class="atc-color">
              Color: <span>${color || ''}</span>
            </div>

            <div class="atc-size">
              Size: <span>${size || ''}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="subtotal_text body-large">
        Order Subtotal (1 items):
        <span class="body-large bold" data-currency="true">
          $ ${(data.price / 100).toFixed(2)}
        </span>
      </div>

      <div class="atc-actions">
        <a class="atc-btn" href="/cart">
          <div>View Cart</div>
        </a>

        <a class="atc-btn" href="/checkout" style="background:#000;color:#fff;">
          <div>Checkout</div>
        </a>
      </div>

      ${recommendHtml}
    `;

    popup.classList.add('is-active');
  }
);

document
  .querySelector('.atc-popup__close')
  .addEventListener('click', () => {

    document
      .getElementById('atc-popup')
      .classList
      .remove('is-active');

});


document.addEventListener('click', function (e) {

  const drawer = document.getElementById('SizeGuideDrawer');

  // OPEN
  if (e.target.closest('[data-open-size-guide]')) {
    drawer.classList.add('active');

    // ⭐ lock body scroll
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = getScrollbarWidth() + 'px';

    return;
  }

  // CLOSE
  if (
    e.target.closest('.size-guide-drawer__close') ||
    e.target.closest('.size-guide-drawer__overlay')
  ) {
    drawer.classList.remove('active');

    // unlock body scroll
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    return;
  }

  // TAB
  const tab = e.target.closest('.size-guide-tab');

  if (tab) {

    const target = tab.dataset.tab;

    document.querySelectorAll('.size-guide-tab')
      .forEach(item => item.classList.remove('active'));

    document.querySelectorAll('.size-guide-content')
      .forEach(item => item.classList.remove('active'));

    tab.classList.add('active');

    const content = document.querySelector(`[data-content="${target}"]`);
    content?.classList.add('active');

    // ⭐ FIX：切 tab 后重置滚动位置（关键）
    const scrollBox = content?.querySelector('.size-guide-table-scroll');
    if (scrollBox) {
      scrollBox.scrollTop = 0;
      scrollBox.scrollLeft = 0;
    }
  }
});


// 计算滚动条宽度（防抖动）
function getScrollbarWidth() {
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  div.style.width = '100px';
  document.body.appendChild(div);

  const width = div.offsetWidth - div.clientWidth;
  div.remove();

  return width;
}



document.querySelectorAll('.copy-block').forEach(block => {
  block.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation(); // ⭐ 防止 a 跳转

    const text = this.dataset.copy;

    // 保存原始内容
    const originalHTML = this.innerHTML;

    navigator.clipboard.writeText(text).then(() => {

      // ⭐ 改成复制成功
      this.innerHTML = 'Copied ✔';

      this.classList.add('copied');

      setTimeout(() => {
        // ⭐ 恢复原内容
        this.innerHTML = originalHTML;
        this.classList.remove('copied');
      }, 2000);

    });
  });
});

// (function () {
//   const DAY_MS = 24 * 60 * 60 * 1000;

//   function pad(n) {
//     return String(n).padStart(2, "0");
//   }

//   function setAll(selector, value) {
//     document.querySelectorAll(selector).forEach(el => {
//       el.textContent = value;
//     });
//   }

//   // 今天下午3点
//   const target = new Date();
//   target.setHours(15, 0, 0, 0);

//   function updateCountdown() {
//     const now = new Date();

//     let diff = target - now;

//     // 到了15:00以后保持0
//     if (diff < 0) diff = 0;

//     const days = Math.floor(diff / DAY_MS);
//     const hours = Math.floor((diff % DAY_MS) / (1000 * 60 * 60));
//     const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//     const secs = Math.floor((diff % (1000 * 60)) / 1000);

//     setAll(".js-pc-days", pad(days));
//     setAll(".js-pc-hours", pad(hours));
//     setAll(".js-pc-mins", pad(mins));
//     setAll(".js-pc-secs", pad(secs));
//   }

//   updateCountdown();
//   setInterval(updateCountdown, 1000);
// })();



document.addEventListener('DOMContentLoaded', function () {
  const tipBtn = document.querySelector('.js-size-tip');

  // 没有 tipBtn 或不是指定页面时退出
  if (!tipBtn || !tipBtn.classList.contains('js-size-tip-one')) return;

  const urlHasVariant = window.location.search.includes('variant=');

  const addBtn = document.querySelector('.product-info__add-button');
  const sizeBtn = document.querySelector('.js-select-variant-btn');
  const fitBtn = document.querySelector('.js-fit-guide-btn');
  const checkoutBtn = document.querySelector('.checkout-wishlist-wrap');

  const sizeWrap = document.querySelector('[data-option="size" i]');
  const lengthWrap = document.querySelector(
    '[data-option="Length"], [data-option="Inseam"]'
  );
  const bandWrap = document.querySelector('[data-option="Band Size"]');
  const cupWrap = document.querySelector('[data-option="Cup Size"]');

  const getLabels = () => ({
    sizeLabel: sizeWrap?.querySelector(
      '.opt-btn:checked + .opt-label--btn'
    ),
    lengthLabel: lengthWrap?.querySelector(
      '.opt-btn:checked + .opt-label--btn'
    ),
    bandLabel: bandWrap?.querySelector(
      '.opt-btn:checked + .opt-label--btn'
    ),
    cupLabel: cupWrap?.querySelector(
      '.opt-btn:checked + .opt-label--btn'
    ),
  });

  const applyNotSelectedClass = (className) => {
    const {
      sizeLabel,
      lengthLabel,
      bandLabel,
      cupLabel
    } = getLabels();

    sizeLabel?.classList.add(className);
    lengthLabel?.classList.add(className);
    bandLabel?.classList.add(className);
    cupLabel?.classList.add(className);
  };

  const showSelectionButtons = () => {
    if (sizeBtn) sizeBtn.style.display = 'block';
    if (fitBtn) fitBtn.style.display = 'flex';
  };

  const hideSelectionButtons = () => {
    if (sizeBtn) sizeBtn.style.display = 'none';
    if (fitBtn) fitBtn.style.display = 'none';
  };

  // 没有选择款式/尺码
  if (!urlHasVariant) {
    if (addBtn) addBtn.style.display = 'none';
    if (checkoutBtn) checkoutBtn.style.display = 'none';

    showSelectionButtons();
    applyNotSelectedClass('variant-not-selected');
  } else {
    if (checkoutBtn) checkoutBtn.style.display = 'block';

    hideSelectionButtons();
  }

  sizeBtn?.addEventListener('click', function () {
    tipBtn.classList.add('is-active');
  });

  document.querySelectorAll('.js-option').forEach((input) => {
    input.addEventListener('click', () => {
      const {
        sizeLabel,
        lengthLabel,
        bandLabel
      } = getLabels();

      sizeLabel?.classList.add('variant-not-selected2');
      lengthLabel?.classList.add('variant-not-selected2');
      bandLabel?.classList.add('variant-not-selected2');

      if (addBtn) addBtn.style.display = 'block';
      if (checkoutBtn) checkoutBtn.style.display = 'block';

      hideSelectionButtons();

      tipBtn.style.display = 'none';
    });
  });
});

document.addEventListener('mouseover', function (e) {
  const swatch = e.target.closest('.color-swatch-slider-pc');
  if (!swatch) return;

  // 当前颜色
  const color = (swatch.dataset.color || '')
    .toLowerCase()
    .trim();

  // 统一格式
  const colorKey = color.replace(/[\s_-]/g, '');

  // 当前商品卡
  const card = swatch.closest(
    'product-card, .card, .product-card, .product'
  );

  if (!card) {
    console.log('❌ card not found');
    return;
  }

  // 找 slider
  const slider = card.querySelector(
    'product-card-image-slider'
  );

  if (!slider) {
    console.log('❌ slider not found');
    return;
  }

  // 当前商品所有图片
  const imgs = card.querySelectorAll(
    '.slider__item img'
  );

  // console.log('colorKey:', colorKey);
  // console.log('images:', imgs.length);
  const first = [...imgs]
  .filter(img => {

    const filename = img.src
      .split('/')
      .pop()
      .split('?')[0]
      .toLowerCase();

    const filenameKey =
      filename.replace(/[\s_-]/g,'');

    return filenameKey.includes(colorKey);

  })
  .sort((a,b)=>{

    const getScore = img => {

      const name = img.src.toLowerCase();

      if(name.includes('-1111')) return 1;

      if(name.includes('-1')) return 2;

      return 3;

    };


    return getScore(a)-getScore(b);

  })[0];



  // console.log('first image:', first);

  if (!first) {
    console.log('❌ first image not found');
    return;
  }

  const slide =
    first.closest('.slider__item');

  if (!slide) {
    console.log('❌ slider item not found');
    return;
  }

  const mediaId =
    slide.dataset.mediaId;

  // 调用 slider 内部过滤逻辑
  slider.handleSwatchChange(
    null,
    mediaId,
    colorKey
  );
});


document.addEventListener('DOMContentLoaded', function(){

  /*
  =========================
  打开弹框
  =========================
  */

  document.querySelectorAll('.open-fit')
  .forEach(button=>{

    button.addEventListener('click',function(e){

      e.preventDefault();

      const id = this.dataset.fitId;

      const modal = document.getElementById(
        'fitModal-' + id
      );

      if(modal){
        modal.classList.add('open');
      }

    });

  });



  /*
  =========================
  关闭弹框
  =========================
  */

  document.querySelectorAll('.fit-modal-close')
  .forEach(button=>{

    button.addEventListener('click',function(e){

      e.preventDefault();

      const id = this.dataset.closeFit;

      const modal = document.getElementById(
        'fitModal-' + id
      );

      if(modal){
        modal.classList.remove('open');
      }

    });

  });



  /*
  =========================
  点击遮罩关闭
  =========================
  */

  document.querySelectorAll('.fit-modal')
  .forEach(modal=>{

    modal.addEventListener('click',function(e){

      if(e.target === modal){

        modal.classList.remove('open');

      }

    });

  });



  /*
  =========================
  尺码表
  =========================
  */

  const sizeTable = {

    "30":{
      "C":"XS",
      "D":"XS+"
    },

    "32":{
      "A":"XS",
      "B":"XS",
      "C":"S",
      "D":"XS+",
      "E":"XS+",
      "F":"S+"
    },

    "34":{
      "A":"S",
      "B":"S",
      "C":"M",
      "D":"S+",
      "E":"S+",
      "F":"M+"
    },

    "36":{
      "A":"M",
      "B":"M",
      "C":"L",
      "D":"M+",
      "E":"M+",
      "F":"L+"
    },

    "38":{
      "A":"L",
      "B":"L",
      "C":"XL",
      "D":"L+",
      "E":"L+",
      "F":"XL+"
    },

    "40":{
      "B":"XL",
      "C":"2XL",
      "D":"XL+",
      "E":"XL+",
      "F":"2XL+"
    },

    "42":{
      "B":"2XL",
      "C":"3XL",
      "D":"2XL+",
      "E":"2XL+",
      "F":"3XL+"
    },

    "44":{
      "B":"3XL",
      "C":"3XL",
      "D":"3XL+",
      "E":"3XL+",
      "F":"4XL+"
    },

    "46":{
      "D":"4XL+",
      "E":"4XL+",
      "F":"5XL+"
    },

    "48":{
      "D":"5XL+",
      "E":"5XL+"
    }

  };



  /*
  =========================
  查询尺码
  =========================
  */

  document.querySelectorAll('.fit-modal-action')
  .forEach(button=>{

    button.addEventListener('click',function(e){

      e.preventDefault();

      const modal = this.closest('.fit-modal');

      if(!modal) return;


      const band = modal.querySelector(
        '.band-select'
      ).value;


      const cup = modal.querySelector(
        '.cup-select'
      ).value;


      const result = modal.querySelector(
        '.fit-result'
      );



      if(!band || !cup){

        result.innerHTML = `
          <strong>
            Please select Band and Cup
          </strong>
        `;

        result.classList.add('show');

        return;

      }



      const recommendedSize =
      sizeTable[band]?.[cup];



      if(!recommendedSize){

        result.innerHTML = `
          <strong>
            No matching size
          </strong>
        `;

        result.classList.add('show');

        return;

      }



      result.innerHTML = `

        <strong>
          Recommended Size: ${recommendedSize}
        </strong>

        <br>

        <span style="color:#666">
          The "+" option gives more cup room at a similar band range.
        </span>

      `;


      result.classList.add('show');


    });

  });


});


document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  const targetId = params.get('scrollTo');

  if (!targetId) return;

  const target = document.getElementById(targetId);
  if (!target) return;

  const header = document.querySelector(
    'sticky-header, .header, .site-header, #shopify-section-header'
  );

  const headerHeight = header ? header.offsetHeight : 0;
  const targetTop =
    target.getBoundingClientRect().top +
    window.scrollY -
    headerHeight -
    20;

  setTimeout(() => {
    window.scrollTo({
      top: targetTop,
      behavior: 'smooth'
    });

    // 滚动完成后清理地址栏参数，避免刷新后重复执行
    setTimeout(() => {
      const cleanUrl = `${window.location.pathname}${window.location.hash}`;
      window.history.replaceState({}, '', cleanUrl);
    }, 1000);
  }, 300);
});


(function () {
  function initToolbarScrollbar(scope) {
    var root = scope || document;

    root
      .querySelectorAll(
        '.products-toolbar__filter-row, .m-six-grid'
      )
      .forEach(function (scrollArea) {
        if (
          scrollArea.dataset.customScrollbarReady === 'true'
        ) {
          return;
        }

        var scrollbar = scrollArea.nextElementSibling;

        if (
          !scrollbar ||
          !scrollbar.classList.contains(
            'products-toolbar__scrollbar'
          )
        ) {
          return;
        }

        var track = scrollbar.querySelector(
          '.products-toolbar__scrollbar-track'
        );

        var thumb = scrollbar.querySelector(
          '.products-toolbar__scrollbar-thumb'
        );

        if (!track || !thumb) return;

        scrollArea.dataset.customScrollbarReady = 'true';

        var dragging = false;
        var startPointerX = 0;
        var startScrollLeft = 0;

        function updateScrollbar() {
          var visibleWidth = scrollArea.clientWidth;
          var totalWidth = scrollArea.scrollWidth;
          var maxScrollLeft = totalWidth - visibleWidth;

          if (maxScrollLeft <= 1) {
            scrollbar.classList.add('is-hidden');
            thumb.style.width = '100%';
            thumb.style.transform = 'translateX(0px)';
            return;
          }

          scrollbar.classList.remove('is-hidden');

          var trackWidth = track.clientWidth;

          var thumbWidth = Math.max(
            36,
            trackWidth * (visibleWidth / totalWidth)
          );

          var maxThumbLeft = Math.max(
            0,
            trackWidth - thumbWidth
          );

          var scrollProgress =
            scrollArea.scrollLeft / maxScrollLeft;

          var thumbLeft =
            maxThumbLeft * scrollProgress;

          thumb.style.width = thumbWidth + 'px';
          thumb.style.transform =
            'translateX(' + thumbLeft + 'px)';
        }

        scrollArea.addEventListener(
          'scroll',
          updateScrollbar,
          { passive: true }
        );

        track.addEventListener('click', function (event) {
          if (event.target === thumb) return;

          var rect = track.getBoundingClientRect();
          var clickX = event.clientX - rect.left;
          var thumbWidth = thumb.offsetWidth;

          var maxThumbLeft =
            track.clientWidth - thumbWidth;

          var targetThumbLeft = Math.max(
            0,
            Math.min(
              clickX - thumbWidth / 2,
              maxThumbLeft
            )
          );

          var maxScrollLeft =
            scrollArea.scrollWidth -
            scrollArea.clientWidth;

          scrollArea.scrollTo({
            left:
              maxThumbLeft > 0
                ? (targetThumbLeft / maxThumbLeft) *
                  maxScrollLeft
                : 0,
            behavior: 'smooth'
          });
        });

        thumb.addEventListener(
          'pointerdown',
          function (event) {
            dragging = true;
            startPointerX = event.clientX;
            startScrollLeft = scrollArea.scrollLeft;

            thumb.classList.add('is-dragging');
            thumb.setPointerCapture(event.pointerId);

            event.preventDefault();
          }
        );

        thumb.addEventListener(
          'pointermove',
          function (event) {
            if (!dragging) return;

            var pointerDistance =
              event.clientX - startPointerX;

            var maxThumbLeft =
              track.clientWidth - thumb.offsetWidth;

            var maxScrollLeft =
              scrollArea.scrollWidth -
              scrollArea.clientWidth;

            if (maxThumbLeft <= 0) return;

            scrollArea.scrollLeft =
              startScrollLeft +
              pointerDistance *
                (maxScrollLeft / maxThumbLeft);
          }
        );

        function stopDragging(event) {
          if (!dragging) return;

          dragging = false;
          thumb.classList.remove('is-dragging');

          if (
            event.pointerId !== undefined &&
            thumb.hasPointerCapture(event.pointerId)
          ) {
            thumb.releasePointerCapture(event.pointerId);
          }
        }

        thumb.addEventListener(
          'pointerup',
          stopDragging
        );

        thumb.addEventListener(
          'pointercancel',
          stopDragging
        );

        if ('ResizeObserver' in window) {
          var observer = new ResizeObserver(
            updateScrollbar
          );

          observer.observe(scrollArea);
          observer.observe(track);
        } else {
          window.addEventListener(
            'resize',
            updateScrollbar
          );
        }

        updateScrollbar();
      });
  }

  function initializeFilterScrollbar() {
    initToolbarScrollbar(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeFilterScrollbar
    );
  } else {
    initializeFilterScrollbar();
  }

  /* 原生筛选 AJAX 更新后重新初始化 */
  document.addEventListener(
    'on:facet-filters:updated',
    initializeFilterScrollbar
  );

  /* Shopify 后台编辑器重新加载 Section */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initToolbarScrollbar(event.target);
    }
  );
})();